var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Ok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #38c20a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-ok_1_",
    "data-name": "icons8-ok (1)",
    className: "cls-1",
    d: "M12,4a8,8,0,1,0,8,8A8.009,8.009,0,0,0,12,4Zm3.424,6.624-4,4a.6.6,0,0,1-.849,0l-2-2a.6.6,0,0,1,.848-.848L11,13.352l3.576-3.576a.6.6,0,0,1,.849.848Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Ok);
export default __webpack_public_path__ + "static/media/icons8-ok.ff83787133c64a27e6e06432faba3776.svg";
export { ForwardRef as ReactComponent };